import { createFileRoute } from '@tanstack/react-router';
import TripsOverviewNew from '../../components/TripsOverviewNew';
import { PERMISSION_RIDES } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/overview-tours/$vehicleId')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_RIDES, ['read'], '/unauthorized', context);
    return {
      ...context,
      isMenuDisabled: true,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  return <TripsOverviewNew />;
}
